"use client";

import * as React from "react";
import { Leaf, Users, Globe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const metrics = [{
  id: 1,
  value: "£2.5B+",
  label: "Capital Deployed",
  icon: Users
}, {
  id: 2,
  value: "15,000+",
  label: "Families Housed",
  icon: Leaf
}, {
  id: 3,
  value: "Net Zero",
  label: "Target by 2030",
  icon: Globe
}];
export default function EsgImpact() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: metricsRef,
    isVisible: areMetricsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="esg-impact" className="relative w-full overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/esg_community_garden.png')] bg-cover bg-center" />
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/95 via-secondary/90 to-secondary/80" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          {}
          <div ref={headerRef} className={`max-w-4xl transition-all duration-1000 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <h2 className="font-default text-4xl font-bold tracking-tight text-secondary-foreground sm:text-5xl md:text-6xl lg:leading-[1.1]">
              Investment with Institutional Integrity and Human Impact.
            </h2>
            <p className="mt-6 max-w-2xl mx-auto text-lg text-secondary-foreground/80 md:text-xl">
              We believe that financial returns and social progress are not mutually exclusive. Our purpose-driven approach ensures every investment creates measurable, positive change for communities.
            </p>
          </div>

          {}
          <div ref={metricsRef} className={`mt-16 grid w-full grid-cols-1 gap-8 sm:grid-cols-3 md:gap-12 lg:gap-16 transition-all duration-1000 delay-300 ${areMetricsVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            {metrics.map((metric, i) => {
            const Icon = metric.icon;
            return <div key={metric.id} data-index={i} className="flex flex-col items-center justify-center space-y-4 p-8 rounded-2xl bg-secondary/40 backdrop-blur-md border border-secondary-foreground/10 shadow-2xl">
                  <div className="p-4 rounded-full bg-secondary/50 border border-secondary-foreground/5">
                    <Icon className="w-8 h-8 text-primary" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="font-default text-5xl font-bold text-primary md:text-6xl">
                      {metric.value}
                    </h3>
                    <p className="text-lg font-semibold text-chart-3 uppercase tracking-wider">
                      {metric.label}
                    </p>
                  </div>
                </div>;
          })}
          </div>

          {}
          <div className="mt-16">
             <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent backdrop-blur-sm">
                
             </Button>
          </div>
        </div>
      </div>
    </section>;
}